<template>
<v-container>
    <v-row align="center" no-gutters class="mb-4">
        <v-text-field v-model="search" placeholder="Rechercher un site" filled rounded dense hide-details class="mr-2" ></v-text-field>
        <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" :color="selectedZone ? 'primary' : 'default'">
                    <v-icon>mdi-filter-variant</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item @click="selectedZone = null">
                    <v-list-item-title>Tous les secteurs</v-list-item-title>
                    <v-list-item-action class="my-0">
                        <v-row no-gutters>
                            <v-btn icon x-small @click.stop="sortOrder = 'asc'" :color="sortOrder === 'asc' ? 'primary' : 'default'">
                                <v-icon small>mdi-sort-alphabetical-ascending</v-icon>
                            </v-btn>
                            <v-btn icon x-small @click.stop="sortOrder = 'desc'" :color="sortOrder === 'desc' ? 'primary' : 'default'">
                                <v-icon small>mdi-sort-alphabetical-descending</v-icon>
                            </v-btn>
                        </v-row>
                    </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-for="zone in zoneList" :key="zone.zon_id" @click="selectedZone = zone.zon_id">
                    <v-list-item-title>
                        <v-icon :color="zone.zon_color" small class="mr-2">mdi-map-marker-radius</v-icon>
                        {{ zone.zon_name }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-row>

    <v-row>
    <v-col cols="12" v-for="item in filteredList" :key="item.sit_id" class="pa-2">
        <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 1 : 3" class="rounded-xl pa-4" style="cursor:pointer;" 
                :to="(inSlider || inSlider == undefined) ? {
                    name: $route.matched[1].name + '-slide-site', params: { ent_id: $route.params.ent_id, sit_id: item.sit_id }
                } : item.sit_id" @click="updateSite(item)">
                <v-row no-gutters>
                    <v-col cols="2" class="">
                        <router-link :to="{ name: 'mapview-slide-site', params: { ent_id: $route.params.ent_id, sit_id: item.sit_id } }">
                        <v-icon size="60" :color="'blue'" class="mr-4" >
                            mdi-map-marker-radius</v-icon>
                        </router-link>
                    </v-col>
                    <v-col cols="7" class="">
                        <span class="text-h6 font-weight-bold mr-2 text-uppercase">{{ item.sit_name }}</span><br />
                        <span class="body-2 grey--text text--darken-2 text-truncate">{{ item.sit_name || item.sit_address || 'Aucun site' }}</span><br />
                        
                        <v-chip :x-small="$root.$mobileView" class="ma-2" label outlined :color="stateListById[item.sit_sta_id].sta_color">
                            {{ stateListById[item.sit_sta_id].sta_label }}
                        </v-chip>
                        <v-chip :x-small="$root.$mobileView" class="ma-2" label outlined :color="(item.zon_color) ? item.zon_color : 'grey'">
                            {{ item.zon_name }}
                        </v-chip>
                        <!--<v-chip :x-small="$root.$mobileView" class="ma-2" label outlined :color="typeListById[item.sit_typ_id].typ_color">{{ typeListById[item.sit_typ_id].typ_name }}</v-chip>-->
                    </v-col>
                    <v-col cols="3" class="text-right">
                        <v-chip :small="$root.$mobileView" label outlined color="green">{{(!$root.$mobileView) ? 'Passage :' : ''}} {{ $date(item.sit_date_lastdonetask).format('DD/MM/YYYY') }}</v-chip>
                    </v-col>
                </v-row>
            </v-card>
        </v-hover>
    </v-col>
    </v-row>
    <v-alert v-if="filteredList.length === 0" type="error" class="mt-4">
    Aucun site enregistré
    </v-alert>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useSiteStore } from '@/stores/site'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import { useZoneStore } from '@/stores/zone'

import { filterUpdateService, siteUpdateService } from '@/rxjsServices';

export default {
    name: 'sites-list',
    props: [ 'sit_ent_id', 'searchBar', 'addItemButton', 'inSlider' ],
    computed: {
        ...mapState(useSiteStore, { itemList: 'itemList', setItem: 'SET_ITEM' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapState(useZoneStore, { zoneList: 'itemList', zoneListById: 'itemListById' }),
        filteredList() {
            let list = this.itemList;
            if (this.selectedZone) {
                list = list.filter(item => item.sit_zon_id === this.selectedZone);
            }
            if (this.search) {
                const searchLower = this.search.toLowerCase();
                list = list.filter(item => {
                    return (
                        item.sit_name.toLowerCase().includes(searchLower) ||
                        item.sit_address.toLowerCase().includes(searchLower) //|| item.lst_site.toLowerCase().includes(searchLower)
                    );
                });
            }
            if (this.sortOrder) {
                const dir = this.sortOrder === 'desc' ? -1 : 1;
                list = [...list].sort((a, b) => {
                    return a.sit_name.localeCompare(b.sit_name) * dir;
                });
            }
            return list;
        }
    },
    data: function () {
        return {
            search: '',
            selectedZone: null,
            sortOrder: null,
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
                { text: 'Nom',    value: 'sit_name', align: 'left'},
                { text: 'Type',   value: 'sit_typ_id', align: 'left'},
                { text: 'Taches', value: 'tsk_id_count', align: 'left'},
                { text: 'Action', value: 'sit_id', align: 'right'},
            ],
        }
    },
    created(){
        // modification au niveau du filtre
        this.subscribeFilter = filterUpdateService.getFilter().subscribe(message => {
            if (message) {
                this.loadItems()
            }
        })
    },
    async mounted () {
        if(this.$root.$mobileView){
            this.headers = [
                { text: 'Nom',    value: 'sit_name', align: 'left'},
                { text: 'Taches', value: 'tsk_id_count', align: 'left'},
                { text: 'Action', value: 'sit_id', align: 'right'},
            ]
        }
        this.loadItems()
        this.fetchZones()
    },
    methods: {
        ...mapActions(useSiteStore, {fetchItems: 'fetchItems', setSiteItem: 'SET_ITEM'}),
        ...mapActions(useZoneStore, { fetchZones: 'fetchItems' }),
        async loadItems(){
            let options = (this.sit_ent_id) ? '&sit_ent_id=' + this.sit_ent_id : ''
            await this.fetchItems('?per_page=false&order_by=sit_name&order_direction=asc&extended=withentity,withcounttask,withzone' + options) //sit_typ_id=SIT02&
        },
        toSliderTask(tskId){
            let name = this.$route.matched[1].name.split('-')
            return {
                name: name[0] + '-' + name[1] + '-slide-task', params: {
                    ent_id: this.$route.params.ent_id, sit_id: this.$route.params.sit_id, tsk_uid: tskId
                }
            }
        },
        updateSite(item){
            this.setItem(item)
            siteUpdateService.sendSite(item)
        }
    },
}
</script>